import React from 'react';
import VanpoolModal from '../helpers/vanpoolModal';
import PredeliveryPopup from'./predeliveryPopup';
import TraditionalPopup from './traditionalPopup';

export default function VanpoolPopup(props) {
        const {active, close, type, goToChoosePlan, saveTraditionalInfo, isIPB} = props

  return (
   <VanpoolModal  active={active}  close={close}>
       {type.traditional ? <TraditionalPopup isIPB={isIPB} saveTraditionalInfo={saveTraditionalInfo} /> : <PredeliveryPopup goToChoosePlan={goToChoosePlan}/>}
    </VanpoolModal>
  )
}

